import React, { Component } from "react";

import { connect } from "react-redux";
import Loading from "../Loading";
import Button from "@material-ui/core/Button";
class ProductNotification extends Component {
  render() {
    const themeColor = this.props.themeColor
      ? this.props.themeColor
      : "#0099cc";

    const { current_product, language, settings } = this.props;

    return (
      <div
        className="border-top border-bottom mb-4 e"
        style={{
          backgroundColor: "white",
          minHeight: "100px",
          marginTop: this.props.type == "bottom" ? 20 : 0,
        }}
      >
        <h4
          className="mt-3 mx-4"
          style={{ float: (language === "arabic" && "right") || "left" }}
        >
          {(language === "arabic" && " احصل على تنبيه عند توفر المنتج") ||
            "Get notified when this product becomes available"}
        </h4>
        <Button
          onClick={this.props.openDialog}
          className={`w-75 mb-3`}
          variant="contained"
          color="primary"
          style={{
            boxShadow: "none",
            textTransform: "none",
            fontSize: "14px",
          }}
          dir={language == "english" ? "ltr" : "rtl"}
        >
          {(language === "arabic" && "احصل على تنبيه") || "Notify me"}
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    current_product: state.store.current_product,
    themeColor: state.store.store.settings.dark,
    settings: state.store.store.settings,
  };
};

export default connect(mapStateToProps)(ProductNotification);
